import { api } from "@/config"
import { normalizeSortingParams } from "@/helpers/vue-good-table"

export default ({ BASE_URI }) => ({
  CHECK_INVENTORY_GROUP_EXISTS: ({ state: { sorting } }, name) => {
    return api.post(`${BASE_URI}/inventory_group_exists`, { name, sorting: normalizeSortingParams(sorting) })
  }
})
